import { Calculator, ShowErrorWay } from "../common/calculator";
import { fields as dateFields, baseDateIntervalCheck, DateIntervalIgnoreEmptyField, DateIntervalField } from "../common/datetime_fields.js";
import { DatePoint } from '../js/datelib.js';

class CFDCalculator extends Calculator {
    code() { return "cfd"; }
    type() { return "CalcCompensationForDismissal"; }

    initialize() {
        let self = this;
        this.patchFieldTypes([DateIntervalField,DateIntervalIgnoreEmptyField]);  // add datefields
        this.setupStatistic({
            calcName: 'comp_otpusk'
        });

        // add input fields
        this.addInputField("#annualVacationDuration input", 'annualVacationDays', {
            type: 'count', showErrorWay: ShowErrorWay.SHOW_FIRST, errors: [
                { check: function (v) { return v !== null; }, selector: '#duration-error' },
                { check: function (v) { return v > 0; }, selector: '#duration-zero-error' },

            ]
        });
        this.addInputField("#totalVacationDays input", 'fullVacationDays', {
            type: 'count', showErrorWay: ShowErrorWay.SHOW_FIRST, errors: [
                { check: function (v) { return v !== null; }, selector: '#used-vacations-input-error' },
                { check: function (v) { return true; }, selector: '#neg-days-calc-error' }
            ]
        });
        this.addInputField("#averageDailyCharge input", 'averageDailySalary', {
            type: 'money', errors: [{ check: function (v) { return !!v; }, selector: '#averageDailyCharge .error-text' }]
        });

        this.mainPeriodField = this.addInputField('.calc-div-input-main > .period-div', 'mainPeriod', {
            showErrorWay: ShowErrorWay.SHOW_FIRST
        });

        this.addGroup('subtractingPeriods', baseDateIntervalCheck, { parent: this.mainPeriodField });

        // add output fields
        function verboseMonthesImpl(monthes, yearsWords, monthesWords) {
            var years = 0 | (monthes / 12);
            var resid = monthes % 12;
            var parts = [];
            if (years)
                parts.push(tools.verboseCountingValue(years, [yearsWords]));
            if (resid || !years)
                parts.push(tools.verboseCountingValue(resid, [monthesWords]));
            return parts.join(' ');
        }

        function verboseMonthes(monthes) {
            return verboseMonthesImpl(monthes, ["год", "года", "лет"], ["месяц", "месяца", "месяцев"]);
        }

        function verboseMonthesRel(monthes) {
            return verboseMonthesImpl(monthes, ["года", "лет", "лет"], ["месяца", "месяцев", "месяцев"]);
        }

        function verboseDays(intVal) {
            return tools.verboseCountingValue(intVal, [["день", "дня", "дней"]]);
        }

        function verboseDuration(duration) {
            var parts = [];
            if (duration.monthes > 0) {
                parts.push(verboseMonthes(duration.monthes));
            }
            if (duration.days > 0 || duration.monthes == 0) {
                parts.push(verboseDays(duration.days));
            }
            return parts.join(' ');
        }

        function getDetailedPeriod(period, subtract) {
            var duration = period.getPeriodDuration(subtract);
            var bounds = period.toLocaleFormat();
            var durationRender = verboseDuration(duration);
            return bounds + ' (' + durationRender + ')';
        }

        let dayVerbose = { type: 'day', render: function (x) { return verboseDays(x); } };
        this.addOutputField('#period-rounded', 'fullyWorkedMonthes', { type: 'rounded', render: function (x) { return verboseMonthes(x); } });
        this.addOutputField('#period-rounded-rel', 'fullyWorkedMonthes', { type: 'roundedRel', render: function (x) { return verboseMonthesRel(x); } });
        this.addOutputField('#period-detailed', 'mainPeriod', { render: function (x) { return getDetailedPeriod(x.dateFrom.getSpan(x.dateTo), self.subtractingPeriodsDays); } });
        this.addOutputField(".positive-compensation-days", "", {
            type: "conditionalBlock",
            render: () => !self.unprocessedDays, 
            alternativeBlock: ".negative-compensation-days"
        });
        this.addOutputField('.alternative-calc-block', '', {
            type: 'note', render: function () {
                let result = !!self.specialCase.value;
                if (result) {
                    $('.alternative-period-duration').text(dayVerbose.render(self.specialCase.details.compensationDays));
                    $('.alternative-compensation-value').html(tools.getLocaleSumInRubbles(self.specialCase.details.compensation));
                }
                return result;
            }
        });
        this.addOutputField('#sub-periods-render-row', '', {
            type: 'note', render: function () {
                let result = self.subtractingPeriods.length > 0;
                if (result) {
                    $('#sub-periods-render-cell').html(self.subtractingPeriods.map(function (elem) {
                        elem.info = getDetailedPeriod(elem.dateFrom.getSpan(elem.dateTo));
                        return '<div class="sub-period-bullet"><div class="name">' + elem.name + '</div><div class="info">' + elem.info + '</div></div>';
                    }).join(''));
                }
                return result;
            }
        });

        $('#totalVacationDays input').focus(tools.selectAllText);

        this.loadDescription();
        this.submitOnClick('#calcSubmit');
        this.addResetButton("#clearCalcInput");

        this.dynamicField = this.addDynamicField('subtractingPeriods', {
            table: "#subPeriodsTable",
            appendButtonSelector: "#addSubPeriods",
            removeSelector: ".dynamic-list-row-remove a",
            keepOne: false,
            prepareTemplate: function($clone, blockPiece){
                $clone.data('rowIndex', blockPiece.index + 1);

                var $comment = $clone.find('.dynamic-list-comment input').change(function () {
                    $(this).data('changed', '1');
                }).focus(tools.selectAllText);
             
                $comment.val($comment.val() + $clone.data('rowIndex'));

                return { block: $clone };
            }
        });
    }

    get defaultFilled(){
        return $("#subPeriodsTable").find('.dynamic-list-row').length > 0;
    }

    onReset() {
        $('.calc-div-results').removeClass('show-results');
    }

    generateExportObject() {
        let result = super.generateExportObject();
        result.periodDescription = tools.convertElemToTextWithLinksForExport($('.period-description-word'));
        result.unprocessedDaysInfo =  tools.convertElemToTextWithLinksForExport($('.negative-compensation-days-addition'));
        result.render.subtracting = this.subtractingPeriods.map(function (elem) {
            return { name: elem.name, info: elem.info };
        });
        result.specialCase = this.specialCase;
        if(this.specialCase.value)
            result.specialCase.details.compensationDaysVerbose = $('.alternative-period-duration').text();
        return result;
    }

    showResults() {
        super.showResults();

        var goalParams = {
            message: "Is_Made",
            args:{
                Not_included_period: this.subtractingPeriods.length > 0,
                Reason_for_leaving: this.reason.value,
                Note_showed: this.specialCase.ym
            }
        };

        this.sendStatisticMessage(goalParams);
    }

    calculate(params) {
        let self = this;
        this.subtractingPeriods = (this.subtractingPeriods || []).sort(function (a, b) {
            return (a.period.dateFrom.goesBefore(b.period.dateFrom) ? -1 : 1);
        }).map(sub => sub.period);
        this.subtractingPeriodsDays = this.subtractingPeriods.map(function (period) {
            return period.dateFrom.distanceTo(period.dateTo);
        }).reduce(function (a, b) { return a + b; }, 0);

        this.periodDuration = this.mainPeriod.dateFrom.getSpan(this.mainPeriod.dateTo).getPeriodDuration(self.subtractingPeriodsDays);
        this.monthlyVacationDays = this.annualVacationDays / 12;
        this.specialCase = { value: false, caseId: -1, ym: false };
        this.notes = {};

        var halfMonthAlgorithms = {
            fifteen: function () {
                return (self.periodDuration.days >= 15);
            },
            alwaysFirst: function () {
                if (self.periodDuration.days < 10 || self.periodDuration.days > 20) {
                    return (self.periodDuration.days > 15);
                }
                return (self.periodDuration.days >= self.periodDuration.residPoint.getDaysInMonth() / 2);
            },
            majority: function () {
                function getMajorMonth() {
                    var resid = self.periodDuration.residPoint;
                    if (resid.date.getDate() < 13)
                        return resid;

                    var monthEnd = resid.copy();
                    monthEnd.fixDayMonthYear(monthEnd.getDaysInMonth());

                    var roundingEnd = resid.copy();
                    roundingEnd.fixDayMonthYear(1, roundingEnd.date.getMonth() + 1);
                    roundingEnd.setDateGently(resid.date.getDate(), true);

                    var leftPeriodDuration = resid.distanceTo(monthEnd);
                    var rightPeriodDuration = monthEnd.distanceTo(roundingEnd) - 2;

                    if (leftPeriodDuration > rightPeriodDuration) {
                        return resid;
                    } else {
                        return roundingEnd;
                    }
                }

                if (self.periodDuration.days < 14 || self.periodDuration.days > 15) {
                    return (self.periodDuration.days > 14.5);
                }
                else {
                    var month = getMajorMonth();
                    return (self.periodDuration.days >= month.getDaysInMonth() / 2);
                }
            }
        };

        var halfIndicators = [
            halfMonthAlgorithms.fifteen(),
            halfMonthAlgorithms.alwaysFirst(),
            halfMonthAlgorithms.majority()
        ];

        function calculateCompensationDetails(halfMonthIndicator, silent=false) {
            var result = {
                valid: true,
                fullyWorkedMonthes: self.periodDuration.monthes + (halfMonthIndicator ? 1 : 0),
            };
            const reasonOwnBothOther = ['own_wish', 'other', 'both_sides'].indexOf(self.reason.value) >= 0;
            const reasonRifWarLiq = ['rif', 'liquidation', 'war'].indexOf(self.reason.value) >= 0;
            const monthes = result.fullyWorkedMonthes;
            if (result.fullyWorkedMonthes % 12 > 10.5) {
                result.fullyWorkedMonthes = ((0 | result.fullyWorkedMonthes / 12) + 1) * 12;
            }
            else if (!reasonOwnBothOther && result.fullyWorkedMonthes % 12 > 5.5) {
                var years = ((0 | result.fullyWorkedMonthes / 12) + 1);
                if (reasonRifWarLiq || years === 1) {
                    result.fullyWorkedMonthes = years * 12;
                }
            }
            if (!silent && result.fullyWorkedMonthes > 12) {
                self.notes.note1 = (reasonOwnBothOther && monthes % 12 > 10.5);
                self.notes.note2 = (reasonRifWarLiq && monthes % 12 > 5.5);
            }

            result.totalVacationDays = tools.round10((self.annualVacationDays * parseInt(result.fullyWorkedMonthes / 12)) + (result.fullyWorkedMonthes % 12) * self.monthlyVacationDays, 2);
            result.compensationDays = tools.round10(result.totalVacationDays - self.fullVacationDays, 2)

            if (result.compensationDays < 0) {
                result.compensationDays = tools.round10((self.annualVacationDays / 12 * result.fullyWorkedMonthes), 2)
                result.unprocessedDays = tools.round10(self.fullVacationDays - result.totalVacationDays, 2);
                result.compensation = self.averageDailySalary *  result.unprocessedDays;
            } else {
                result.compensation = self.averageDailySalary * result.compensationDays;
            }

            return result;
        }

        var details = calculateCompensationDetails(halfIndicators[0]);
        if (halfIndicators.reduce(function (x, y) { return x + y; }) % 3 !== 0) {
            self.specialCase.ym = true;
            self.specialCase.details = calculateCompensationDetails(!halfIndicators[0], true);
            if (self.subtractingPeriodsDays === 0) {
                self.specialCase.value = true;
                self.specialCase.caseId = 1;      // just potential possibility to separate different cases.
            }
            
            if (self.specialCase.details.unprocessedDays > 0 || self.specialCase.details.compensationDays == details.compensationDays) {
                self.specialCase.value = false;
                self.specialCase.ym = false;
            }
        }

        //console.log(details);
        if (!details.valid) {
            var $error = $('#neg-days-calc-error');
            var elem = $('#totalVacationDays')[0];
            if (!params.autoValidation || params.sender === elem) {
                elem.classList.add('err');
                $('#dateFrom, #dateTo').addClass('err');
                $error.show();
            } else if (params.sender === elem.getElementsByTagName('input')[0] && elem.classList.contains('err')) {
                $error.show();
            }
            return false;
        } else {
            self.fullyWorkedMonthes = details.fullyWorkedMonthes;
            self.totalVacationDays = details.totalVacationDays;
            self.compensationDays = details.compensationDays;
            self.compensation = details.compensation;
            self.unprocessedDays = details.unprocessedDays;
        }
        console.log(this.notes);

        return true;
    }
}

$(function () {
    var calc = new CFDCalculator();
    calc.debug = false;
    /*
    window.fill = function () {
        $('#averageDailyCharge input').val(1000);
        $('#dateFrom').val('05.01.2018');
        $('#dateTo').val('19.07.2019');

    };

    window.fill();
    */
});
